import { useTranslation } from 'react-i18next';
import { BenefitKindEnum, formatCurrency } from 'utils';

// Benefit of a promotion as listed by the promotions API (-10%, +20 EUR, 2 free nights…).
const PromotionBenefit = ({ promotion }) => {
  const { t } = useTranslation(['promotions', 'promotionForm']);
  let amount;
  const benefit = promotion?.benefit;
  if (!benefit || !benefit.kind) return '-';
  if (
    promotion?.isExperience ||
    benefit?.promoPerRoom ||
    benefit?.benefitAgeGroups?.length === 0
  ) {
    amount = benefit.value;
  } else {
    amount = benefit?.benefitAgeGroups?.reduce((prev, current) => {
      return prev.age > current.age ? prev : current;
    }, {})?.value;
  }

  if (benefit?.kind === BenefitKindEnum.percent) {
    return <span>-{amount}%</span>;
  }
  if (benefit?.kind === BenefitKindEnum.supplement_percent) {
    return <span>+{amount}%</span>;
  }
  if (benefit?.kind === BenefitKindEnum.supplement) {
    return (
      <span>
        +
        {formatCurrency({
          amount: amount,
          currency: benefit?.currency?.toUpperCase(),
        })}
      </span>
    );
  }
  if (benefit?.kind === BenefitKindEnum.amount) {
    return (
      <span>
        -
        {formatCurrency({
          amount: amount,
          currency: benefit?.currency?.toUpperCase(),
        })}
      </span>
    );
  }
  if (benefit?.kind === BenefitKindEnum.upgrade_room) {
    return (
      <span>{t('promotionTypes.upgrade_room', { ns: 'promotionForm' })}</span>
    );
  }
  if (benefit?.kind === BenefitKindEnum.free_night) {
    const amount = benefit?.value;
    const label = amount > 1 ? 'freeNights.plural' : 'freeNights.single';
    return (
      <span>
        {amount} {t(label)}
      </span>
    );
  }
  if (benefit?.kind === BenefitKindEnum.amenity) {
    const amount = benefit?.amenities?.length;
    const label = amount > 1 ? 'amenities.plural' : 'amenities.single';
    return (
      <span>
        {amount} {t(label)}
      </span>
    );
  }
  return 'N/A';
};

export default PromotionBenefit;
